import {Component, ElementRef, NgZone, OnInit, ViewChild} from '@angular/core';
import {BookingService} from "../booking.service";
import {ActivatedRoute} from "@angular/router";
import {LoadingWheelService} from "../../../root/loading/loading-wheel.service";
import * as _ from "lodash";
import {SessionService} from "../../../core/session.service";
import {InformationModalService} from "../../../root/information-modal/information-modal.service";
import {NotificationService} from "../../../root/toast/notification.service";
import * as moment from "moment";
import {Location} from '@angular/common';
import {TranslateService} from "@ngx-translate/core";
import {AirportCodeEnum} from "../../pointOfSale/airport-code.enum";

@Component({
    selector: 'booking-detail',
    templateUrl: './booking-detail.component.html',
    providers: [BookingService]
})
export class BookingDetailComponent implements OnInit {


    constructor(private bookingService:BookingService, private route: ActivatedRoute,
                private loading: LoadingWheelService, private zone:NgZone,
                private session: SessionService, private informationModalService: InformationModalService,
                private notification: NotificationService, private location: Location,
                private translateService: TranslateService){
    }
    private companyOid:number;
    private bookingOid:number;
    private cancunOid:number = AirportCodeEnum.CANCUN_AIRPORT;
    private orlandoOid:number = AirportCodeEnum.ORLANDO_AIRPORT;
    private miamiOid: number = AirportCodeEnum.MIAMI_AIRPORT;

    bookingDetail:any = {};
    showBookingDetail:boolean = false;
    bookingHistories:any = {};
    bookingStatusColor: string = '';
    bookingStatusNumber: number = 4;
    hasSpecialOffer: boolean;
    upgradeCar:any;
    offerType:boolean;
    hasOpaqueDiscount: boolean;
    permViewMarkup: boolean;
    vccActiveTo;
    print;
    historyVisible: boolean;
    companyMail:string;
    clientMail:string;
    isButtonHidden:boolean=false;
    promotionValue:string="-";
    miamiAirportPositions:string="";
    miamiAirportPositions_last:string="";
    indications;
    isPhoneReq:boolean;
    isPhoneOpt:boolean;

    ngOnInit(){
        this.initialize();
    }

    initialize() {
        this.setInformationModal();
        this.loading.show();
        this.route.queryParams.subscribe( params => {
            this.print = params.print;
        });
        this.route.params.subscribe(params => {
            this.companyOid = params['companyId'];
            this.bookingOid = params['id'];

            this.zone.run(() => {
                this.loading.show();

                if (this.companyOid && this.bookingOid){
                    let bookingDetail;
                    let bookedPricesDto;

                    this.bookingService.getOne(this.companyOid, this.bookingOid).subscribe(result => {
                        this.showBookingDetail = true;
                        this.historyVisible = true;
                        this.bookingDetail = result.booking;
                        this.indications = this.bookingDetail.pickupPoint.pickupIndications;
                        bookingDetail = this.bookingDetail;
                        bookedPricesDto = bookingDetail.bookedPricesDto
                        this.bookingHistories = result.histories;
                        this.upgradeCar = bookedPricesDto[0].upgradeCar;
                        this.permViewMarkup = this.session.loggedUserAllowed('PERM_MARKUP_VIEW');
                        this.hasSpecialOffer = this.hasSpecialOfferApplied(bookedPricesDto);
                        this.hasOpaqueDiscount = this.hasOpaqueDiscountApplied(bookedPricesDto);
                        this.platformsString();
                        this.isPhoneReq = this.isPhoneRequired();
                        this.isPhoneOpt = this.isPhoneOptional();


                        this.setBookingStatusColor(bookingDetail.status);

                        if(bookingDetail.vccActiveTo){
                            this.vccActiveTo = this.formatDate(bookingDetail.vccActiveTo);
                        }

                        this.loading.hide();

                        if(this.print && bookingDetail){
                            setTimeout(function(){
                                window.print();
                            }, 1500);
                        }
                    })
                }
            })
        });

    }

    formatDate(date) {
        var day = date.dayOfMonth;
        var month = date.monthOfYear;
        var year = date.year;

        return day + '/' + month + '/' + year;
    }

    setInformationModal() {
        this.informationModalService.setInformationModalData({
            title: 'bookingDetail.vcc.faq.TITLE',
            groupText: [{
                subtitle: 'bookingDetail.vcc.faq.SUBTITLE_1',
                texts: ['bookingDetail.vcc.faq.SUBTITLE_1.DESCRIPTION', 'bookingDetail.vcc.faq.SUBTITLE_1.ITEM_1', 'bookingDetail.vcc.faq.SUBTITLE_1.ITEM_2', 'bookingDetail.vcc.faq.SUBTITLE_1.ITEM_3']
            }, {
                subtitle: 'bookingDetail.vcc.faq.SUBTITLE_2',
                texts: ['bookingDetail.vcc.faq.SUBTITLE_2.ITEM_1']
            }, {
                subtitle: 'bookingDetail.vcc.faq.SUBTITLE_3',
                texts: ['bookingDetail.vcc.faq.SUBTITLE_3.ITEM_1']
            }
            ]
        })
    }

    hasSpecialOfferApplied(bookedPrices){
        var result = _.find(bookedPrices, function (bookedPrice){
            return bookedPrice.specialOfferName;
        });

        return result ? true : false;
    };

    hasOpaqueDiscountApplied(bookedPrices){
        var result = _.find(bookedPrices, function (bookedPrice){
            return bookedPrice.opaqueRateName;
        });

        return result ? true : false;
    };

    isDefined(object){
        return (object != null && object != undefined && object.trim() != '');
    };

    setBookingStatusColor(status) {
        switch (status) {
            case 'BOOKED':
                this.bookingStatusColor = 'green';
                this.bookingStatusNumber = 2;
                break;
            case 'CANCELED':
                this.bookingStatusColor = 'red';
                this.bookingStatusNumber = 2;
                break;
            case 'MODIFIED':
                this.bookingStatusColor = 'light-blue';
                break;
            case 'NO_SHOW':
                this.bookingStatusColor = 'orange';
                break;
            case 'REVERTED':
                this.bookingStatusColor = 'red';
                this.bookingStatusNumber = 2;
                break;
        }
    }

    isCommissionableOrMarkupVisible(view, commissionType) {
        return view || commissionType == 'COMMISSIONABLE';
    }

    @ViewChild('dp1') dp1: ElementRef;
    @ViewChild('dp2') dp2: ElementRef;
    @ViewChild('dp3') dp3: ElementRef;
    @ViewChild('dp4') dp4: ElementRef;
    @ViewChild('dp5') dp5: ElementRef;
    @ViewChild('dp6') dp6: ElementRef;

    download() {
        this.loading.show();
        this.dp2.nativeElement.open();
        this.dp3.nativeElement.open();
        this.dp6.nativeElement.open();

        if(this.bookingHistories != null && this.bookingHistories.length > 0 && this.historyVisible){
            this.dp1.nativeElement.open();
        }

        if(this.bookingDetail.additionalsExcludedFromTotal.length > 0){
            this.dp4.nativeElement.open();
        }

        if(this.bookingDetail.additionalsIncludedOnTotal.length > 0){
            this.dp5.nativeElement.open();
        }

        setTimeout(() => {
            this.loading.hide();
            window.print();
        }, 1000);
    }

    showVcc() {
        this.loading.show();
        this.bookingService.getVcc(this.companyOid, this.bookingOid).subscribe(result => {
            this.informationModalService.setVcc(result, this.bookingDetail.period.to);
            this.informationModalService.showVcc();
            this.loading.hide();
        });
    }

    showFaq() {
        this.informationModalService.showInformationModal();
    }

    performNoShow() {
        this.bookingService.performNoShow(this.companyOid, this.bookingOid).subscribe(result => {
            this.initialize();
            this.notification.notifyInfoByCode('bookingDetail.confirmationMessage.SUCCESS_NO_SHOW');

        });
    }

    hideNoShow(){
        return !(this.bookingDetail.cancellable &&
            (( this.bookingDetail.noShowAllowed && this.loggedUserAllowed('PERM_BOOKING_NO_SHOW_VIEW') ) ||
                ( this.bookingDetail.noShowPlusAllowed && this.loggedUserAllowed('PERM_BOOKING_NO_SHOW_PLUS_VIEW') )) )
    }

    loggedUserAllowed(perm) {
        return this.session.loggedUserAllowed(perm);
    }

    isEqualPickup(booking, history) {
        return this.isEqualsLocation(booking.pickupPoint, history.pickupPoint) &&
            this.isEqualsStreet(booking.pickupPoint, history.pickupPoint)
    }

    isEqualDropoff (booking, history){
        return this.isEqualsLocation(booking.dropoffPoint, history.dropoffPoint) &&
            this.isEqualsStreet(booking.dropoffPoint, history.dropoffPoint);
    }

    isEqualsLocation(point1, point2){
        return point1.locationOid == point2.locationOid;
    }

    isEqualsStreet(point1, point2){
        return point1.street == point2.street;
    }

    buildAddress(point){
        var address = point.name + " / " + point.locationName;

        if (point.street != undefined){
            address = address + " " + point.street;
        }

        return address;
    }

    getDay(date) {
        return this.convertToDate(date).getUTCDay();
    }

    getDate(date) {
        return this.convertToDate(date).getUTCDate();
    }

    getMonth(date) {
        return this.convertToDate(date).getUTCMonth() + 1;
    }

    getYear(date) {
        return this.convertToDate(date).getUTCFullYear();
    }

    getHour(date) {
        var d = this.convertToDate(date);

        return moment(d).utc().format('HH:mm');
    }

    // Obtiene la fecha y hora de booking de acuerdo a la hora local
    getBookingFullDate(date) {
        const dateObj = this.convertToDate(date);
        return (
            dateObj.getDate() +
            " " +
            this.translateService.instant(
              "common.month.short." + (dateObj.getMonth() + 1)
            ) +
            " " +
            dateObj.getFullYear() +
            " - " +
            moment(dateObj).format("HH:mm")
        );
    }

    getVccDate(date) {
        var d = this.convertToDate(date);

        return moment(d).utc().format('DD/MM/YYYY');
    }

    convertToDate(date) {
        return new Date(date);
    }

    shouldViewVcc(){
        return this.session.loggedUserAllowed("PERM_VCC_VIEW");
    }

    hideVcc(){
        return !(this.bookingDetail.paymentMethod == 'PREPAYMENT' &&  this.shouldViewVcc());
    }

    goToBookingList() {
        this.location.back();

        /*var url = `company/${this.companyOid}/booking?bookingOID=${this.bookingOid}&filterId=FILTERED&detail=true`;
        window.open(url,"_self");*/

       /* var diffDays = moment(day, 'YYYY-MM-DD').diff(moment(), 'days');
        this.gaService.notify("Autos_inicio_pickup", "seleccionar_reserva", [diffDays]);
        var datePlusWeek = new Date(day);
        var dataType = "PICK_UP";
        datePlusWeek.setDate(datePlusWeek.getDate() + 1);
        var url = `company/${companyId}/booking?from=${this.dateService.formatDateToYYYYMMDD(datePlusWeek)}&to=${this.dateService.formatDateToYYYYMMDD(datePlusWeek)}&landing=true`
        */
    }
    listedBookedInsurences() {
       var insurancesArray = this.bookingDetail.bookedInsurances;
       var array= insurancesArray.map(function (insu){
           return insu.insurance.code;
       });

       return array.join();
    }

    copyMail() {
        let el = document.getElementById('eva-input-mail');
        el.focus();
        document.execCommand('selectAll');
        document.execCommand('copy');
        el.blur();
        this.isButtonHidden = true;
    }

    checkOfferType(bookedPrice:any){
       let upgradeType:string = '-';

        if(bookedPrice.specialOfferName){
           upgradeType = this.upgradeCar ? 'Upgrade': 'Discount';
       }

       return upgradeType;
    }

    platformsString() {
        let positionRCCArray;

        if(this.indications) {
            positionRCCArray = this.indications.miamiAirportPositions;
            if(positionRCCArray) {
                if(positionRCCArray.length > 1) {
                    positionRCCArray.sort();
                    this.miamiAirportPositions = positionRCCArray.slice(0,-1).join(', ');
                    this.miamiAirportPositions_last = positionRCCArray.slice(-1)[0];
                }
                else {
                    this.miamiAirportPositions = positionRCCArray.toString();
                }
            }
        }

    }

    isMultipleCancun() {
        let multiple = false;

        if(this.indications && this.indications.cancunIn && this.indications.cancunOut) {
            multiple = true;
        }
        return multiple;
    }

    cancunHasCounter() {
        return this.indications && this.indications.cancunAirportPositions.hasCounter;
    }

    isCancunAirport() {
        return this.bookingDetail.pickupPoint.locationOid == this.cancunOid &&
            this.indications;
    }

    getTerminalCancun(position?:string) {
        if(position) {
            return position === "IN" ? this.indications.cancunIn : this.indications.cancunOut;
        }
        else {
            return this.indications.cancunIn ? this.indications.cancunIn : this.indications.cancunOut;
        }
    }

    getOrlandoPlatforms(position?:string) {
        let result = "";
        if(position) {
            result = position === "A" ? this.indications.orlandoA : this.indications.orlandoB;
        }
        else {
            result = this.indications.orlandoA ? this.indications.orlandoA : this.indications.orlandoB;
        }
        return result.replace(/{to}/g, this.translateService.instant("bookingDetail.position.orlando.range.to"));
    }

    isInPosition() {
        return this.indications.cancunIn ? "in" : "out";
    }

    isOrlandoAirport() {
        return this.bookingDetail.pickupPoint.locationOid === this.orlandoOid &&
            this.indications;
    }

    isMiamiAirport() {
        return this.bookingDetail.pickupPoint.locationOid == this.miamiOid &&
            this.indications;
    }

    isMultipleOrlando() {
        let multiple = false;
        if(this.indications && this.indications.orlandoA && this.indications.orlandoB) {
            multiple = true;
        }
        return multiple;
    }

    getOrlandoTerminal() {
        return this.indications.orlandoA ? "A" : "B";
    }

    isPhoneRequired() {
        return this.bookingDetail.pickupPoint.pickupIndications &&
            this.bookingDetail.pickupPoint.pickupIndications.phoneRequired;
    }

    isPhoneOptional() {
        return this.bookingDetail.pickupPoint.pickupIndications &&
            this.bookingDetail.pickupPoint.pickupIndications.phoneOptional;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/booking/detail/booking-detail.component.ts